import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"


const api = new APIClient();

// Get List
export const syncContactData = (key: string) => api.get(`${url.SYNC_CONTACT_DATA}/${key}`, null)